import {EventType, MealType, AlcoholType, DietType, CostType} from "../models/data";

export function enumNameFilter() {
  var events = [
    {
      value: EventType.PUBLIC,
      label: "CREATE.EVENT_TYPE_PUBLIC"
    },
    {
      value: EventType.PRIVATE,
      label: "CREATE.EVENT_TYPE_PRIVATE"
    },
    {
      value: EventType.MANUAL,
      label: "CREATE.EVENT_TYPE_MANUAL"
    },
    {
      value: EventType.ALL,
      label: "CREATE.EVENT_TYPE_ALL"
    }
  ];


  var eventExplainations = [
    {
      value: EventType.PUBLIC,
      label: "CREATE.EVENT_TYPE_PUBLIC_HELP"
    },
    {
      value: EventType.PRIVATE,
      label: "CREATE.EVENT_TYPE_PRIVATE_HELP"
    },
    {
      value: EventType.MANUAL,
      label: "CREATE.EVENT_TYPE_MANUAL_HELP"
    },
    {
      value: EventType.ALL,
      label: "CREATE.EVENT_TYPE_ALL_HELP"
    }
  ];


  var meals = [
    {
      value: MealType.HOME_COOKED,
      label: "CREATE.MEAL_TYPE_HOME_COOKED"
    },
    {
      value: MealType.ORDERED_IN,
      label: "CREATE.MEAL_TYPE_ORDERED_IN"
    },
    {
      value: MealType.BUFFET,
      label: "CREATE.MEAL_TYPE_BUFFET"
    }
  ];

  var alcohols = [
    {
      value: AlcoholType.HOST_PROVIDES,
      label: "CREATE.ALCOHOL_TYPE_HOST_PROVIDES"
    },
    {
      value: AlcoholType.BYOB,
      label: "CREATE.ALCOHOL_TYPE_BYOB"
    },
    {
      value: AlcoholType.ALCOHOL_FREE,
      label: "CREATE.ALCOHOL_TYPE_FREE"
    },
    {
      value: AlcoholType.ALL,
      label: "CREATE.ALCOHOL_TYPE_ALL"
    }
  ];

  var diets = [
    {
      value: DietType.VEGETARIAN,
      label: "CREATE.DIET_TYPE_VEGETARIAN"
    },
    {
      value: DietType.VEGAN,
      label: "CREATE.DIET_TYPE_VEGAN"
    },
    {
      value: DietType.GLUTEN_FREE,
      label: "CREATE.DIET_TYPE_GLUTEN_FREE"
    },
    {
      value: DietType.KOSHER,
      label: "CREATE.DIET_TYPE_KOSHER"
    },
    {
      value: DietType.ALL,
      label: "CREATE.DIET_TYPE_ALL"
    }
  ];


  var costs = [
    {
      value: CostType.FREE,
      label: "CREATE.COST_TYPE_FREE"
    },
    {
      value: CostType.PAID,
      label: "CREATE.COST_TYPE_PAID"
    },
    {
      value: CostType.ALL,
      label: "CREATE.COST_TYPE_ALL"
    }
  ];


  var label = (value: number, events: any[], defaultOnError: string) => {
    for (var i = 0; i < events.length; i++) {
      if (events[i].value == value) {
        return events[i].label;
      }
    }

    return defaultOnError ? defaultOnError : "Error";
  }

  return (value: number, enumName: string, defaultOnError: string) => {
    switch(enumName) {
      case "event":
        return label(value, events, defaultOnError);
      case "eventExplanation":
        return label(value, eventExplainations, defaultOnError);
      case "meal":
        return label(value, meals, defaultOnError);
      case "alcohol":
        return label(value, alcohols, defaultOnError);
      case "diet":
        return label(value, diets, defaultOnError);
      case "cost":
        return label(value, costs, defaultOnError);
      default:
        return defaultOnError ? defaultOnError : "Error";
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/filters/enumName.ts
 **/